export default __webpack_public_path__ + "static/media/QCP-capital.7ce5dca8.svg";